import StoryletService from 'services/StoryletService';

export default suggestContact(new StoryletService());

export function suggestContact(service) {
  return branchId => async () => {
    const { data } = await service.suggestContact(branchId);
    return data;
  };
}